_getUserDataLanguageThunk